import { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, Input, Label, FormGroup, Button, FormFeedback } from 'reactstrap';
import Select from 'react-select';
import useObtenerClienteById from '../Hooks/useObtenerClienteById';
import useUpdateCliente from '../Hooks/useUpdateCliente';
import ConfirmCloseModal from '../Common/ConfirmCloseModal';
import ErrorAlert from '../Common/ErrorAlert';
import { isValidRUTFormat } from '../../utils/rut';

// Boolean fields that must be converted from true/false to 1/0 before API submission
const BOOLEAN_FIELDS = ['SINEMAIL', 'SINFECHA', 'SINODC', 'SINNAC', 'SININT', 'RECARGO_FLAG', 'AUTDVE', 'BLOLCH'];

const ModalModificarCliente = ({ isOpen, toggle, onSave, selectedCliente }) => {
    const [isDirty, setIsDirty] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [saveError, setSaveError] = useState('');
    const [validationErrors, setValidationErrors] = useState({});
    const [formData, setFormData] = useState({
        CLIPRO: '',
        TPERSO: '',
        RAZSOC: '',
        APENOM: '',
        APEPAT: '',
        APEMAT: '',
        NOMNOM: '',
        COPAIS: '',
        CODCIU: '',
        CIUDAD: '',
        CODCOM: '',
        COMUNA: '',
        DIRECC: '',
        ELGIRO: '',
        CEMAIL: '',
        CONTAC: '',
        NFONO1: '',
        NFONO2: '',
        NFONO3: '',
        ZIPCOD: '',
        ELSEXO: '',
        SINNAC: false,
        FECNAC: '',
        TIPPRO: '',
        NOMPAG: '',
        TIPPAG: '',
        FORPAG: '',
        NROCTA: '',
        BANCTA: '',
        SUCCTA: '',
        CODSUC: '',
        NOMRET: '',
        RUTRET: '',
        TIPCLI: '',
        SININT: false,
        FLUPRO: '',
        FLUCLI: '',
        PAGCON: '',
        PAGDIA: '',
        PAGFON: '',
        PAGMAI: '',
        AUTDVE: false,
        USUDVE: '',
        // FECADV: '',
        BLOLCH: false,
        USUBLH: '',
        //FECBLH: '',
        CALLES: '',
        NROCAS: '',
        NRODEP: '',
        NROBLO: '',
        SECPOB: '',
        PORDES: '',
        PORSER: '',
        PORREN: '',
        PORRE1: '',
        PORRE2: '',
        SINODC: false,
        LISPRE: '',
        SINEMAIL: false,
        SINFECHA: false,
        CUPO_CREDITO: '',
        SALDO_CREDITO: '',
        UTILIZADO_CREDITO: '',
        ESTADO_CREDITO: '',
        IDSUCURSAL: '',
        RECARGO_FLAG: false,
        RECARGO_MONTO: '',
        FLAG_SIGA: '',
        FLAG_EXT: '',
        USUCRE: '',
        FECCRE: '',
        USUACT: '',
        FECACT: '',
        ULTIMA_ACTUALIZACION: ''
    });

    const { cliente, loading: loadingCliente } = useObtenerClienteById(isOpen ? selectedCliente : null);
    const { updateCliente, loading: updating } = useUpdateCliente();

    console.log('ModalModificarCliente render - cliente:', cliente, 'loadingCliente:', loadingCliente, 'selectedCliente:', selectedCliente);

    useEffect(() => {
        console.log('useEffect triggered - Selected Cliente ID:', selectedCliente, 'cliente:', cliente);
        if (cliente) {
            console.log('Setting formData from cliente:', cliente);
            setFormData({
                CLIPRO: cliente.CLIPRO || '',
                TPERSO: cliente.TPERSO || '',
                RAZSOC: cliente.RAZSOC || '',
                APENOM: cliente.APENOM || '',
                APEPAT: cliente.APEPAT || '',
                APEMAT: cliente.APEMAT || '',
                NOMNOM: cliente.NOMNOM || '',
                COPAIS: cliente.COPAIS || '',
                CODCIU: cliente.CODCIU || '',
                CIUDAD: cliente.CIUDAD || '',
                CODCOM: cliente.CODCOM || '',
                COMUNA: cliente.COMUNA || '',
                DIRECC: cliente.DIRECC || '',
                ELGIRO: cliente.ELGIRO || '',
                CEMAIL: cliente.CEMAIL || '',
                CONTAC: cliente.CONTAC || '',
                NFONO1: cliente.NFONO1 || '',
                NFONO2: cliente.NFONO2 || '',
                NFONO3: cliente.NFONO3 || '',
                ZIPCOD: cliente.ZIPCOD || '',
                ELSEXO: cliente.ELSEXO || '',
                SINNAC: cliente.SINNAC || false,
                FECNAC: cliente.FECNAC || '',
                TIPPRO: cliente.TIPPRO || '',
                NOMPAG: cliente.NOMPAG || '',
                TIPPAG: cliente.TIPPAG || '',
                FORPAG: cliente.FORPAG || '',
                NROCTA: cliente.NROCTA || '',
                BANCTA: cliente.BANCTA || '',
                SUCCTA: cliente.SUCCTA || '',
                CODSUC: cliente.CODSUC || '',
                NOMRET: cliente.NOMRET || '',
                RUTRET: cliente.RUTRET || '',
                TIPCLI: cliente.TIPCLI || '',
                SININT: cliente.SININT || false,
                FLUPRO: cliente.FLUPRO || '',
                FLUCLI: cliente.FLUCLI || '',
                PAGCON: cliente.PAGCON || '',
                PAGDIA: cliente.PAGDIA || '',
                PAGFON: cliente.PAGFON || '',
                PAGMAI: cliente.PAGMAI || '',
                AUTDVE: cliente.AUTDVE || false,
                USUDVE: cliente.USUDVE || '',
                // FECADV: cliente.FECADV || '',
                BLOLCH: cliente.BLOLCH || false,
                USUBLH: cliente.USUBLH || '',
                // FECBLH: cliente.FECBLH || '',
                CALLES: cliente.CALLES || '',
                NROCAS: cliente.NROCAS || '',
                NRODEP: cliente.NRODEP || '',
                NROBLO: cliente.NROBLO || '',
                SECPOB: cliente.SECPOB || '',
                PORDES: cliente.PORDES || '',
                PORSER: cliente.PORSER || '',
                PORREN: cliente.PORREN || '',
                PORRE1: cliente.PORRE1 || '',
                PORRE2: cliente.PORRE2 || '',
                SINODC: cliente.SINODC || false,
                LISPRE: cliente.LISPRE || '',
                SINEMAIL: cliente.SINEMAIL || false,
                SINFECHA: cliente.SINFECHA || false,
                CUPO_CREDITO: cliente.CUPO_CREDITO || '',
                SALDO_CREDITO: cliente.SALDO_CREDITO || '',
                UTILIZADO_CREDITO: cliente.UTILIZADO_CREDITO || '',
                ESTADO_CREDITO: cliente.ESTADO_CREDITO || '',
                IDSUCURSAL: cliente.IDSUCURSAL || '',
                RECARGO_FLAG: cliente.RECARGO_FLAG || false,
                RECARGO_MONTO: cliente.RECARGO_MONTO || '',
                FLAG_SIGA: cliente.FLAG_SIGA || '',
                FLAG_EXT: cliente.FLAG_EXT || ''
            });
        }
    }, [cliente]);

    const validateForm = (formData) => {
        const errors = {};
        const tperso = formData.TPERSO;

        if (!tperso) {
            errors.TPERSO = 'Tipo de Persona es requerido';
        }

        if (!isValidRUTFormat(formData.CLIPRO)) {
            errors.CLIPRO = 'El RUT debe tener formato XXXXXXXX-X (sin puntos, con guión)';
        }

        if (tperso === 'E') {
            if (!formData.RAZSOC?.trim()) errors.RAZSOC = 'Razón Social es requerido';
        } else if (tperso === 'P') {
            if (!formData.NOMNOM?.trim()) errors.NOMNOM = 'Nombres es requerido';
            if (!formData.APEPAT?.trim()) errors.APEPAT = 'Apellido Paterno es requerido';
            if (!formData.APEMAT?.trim()) errors.APEMAT = 'Apellido Materno es requerido';
        }

        if (!formData.DIRECC?.trim()) errors.DIRECC = 'Dirección es requerida';
        if (!formData.CIUDAD?.trim()) errors.CIUDAD = 'Ciudad es requerida';
        if (!formData.COMUNA?.trim()) errors.COMUNA = 'Comuna es requerida';
        if (!formData.NFONO1?.trim()) errors.NFONO1 = 'Teléfono es requerido';
        if (!formData.ELGIRO?.trim()) errors.ELGIRO = 'Giro es requerido';

        if (!formData.SINEMAIL && !formData.CEMAIL?.trim()) {
            errors.CEMAIL = 'Email es requerido';
        }

        return errors;
    };

    const clearValidationErrors = (name) => {
        if (validationErrors[name]) {
            setValidationErrors(prev => {
                const next = { ...prev };
                delete next[name];
                return next;
            });
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setIsDirty(true);
        setSaveError('');
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        clearValidationErrors(name);
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setIsDirty(true);
        setSaveError('');
        setFormData(prev => ({ ...prev, [name]: checked }));
        clearValidationErrors(name);
    };

    const buildPayload = (formData) => {
        const payload = { ...formData };
        BOOLEAN_FIELDS.forEach(field => {
            payload[field] = formData[field] ? 1 : 0;
        });
        if (formData.SINEMAIL) {
            payload.CEMAIL = null;
        }
        return payload;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaveError('');

        const errors = validateForm(formData);
        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);
            return;
        }

        const payload = buildPayload(formData);
        const result = await updateCliente(selectedCliente, payload);
        if (result.success) {
            setIsDirty(false);
            onSave(formData);
            handleCancel();
        } else {
            setSaveError(result.error || 'Error al actualizar cliente');
        }
    };

    const handleCancel = () => {
        if (isDirty) {
            setShowConfirm(true);
            return;
        }
        setFormData({
            CLIPRO: '',
            TPERSO: '',
            RAZSOC: '',
            APENOM: '',
            APEPAT: '',
            APEMAT: '',
            NOMNOM: '',
            COPAIS: '',
            CODCIU: '',
            CIUDAD: '',
            CODCOM: '',
            COMUNA: '',
            DIRECC: '',
            ELGIRO: '',
            CEMAIL: '',
            CONTAC: '',
            NFONO1: '',
            NFONO2: '',
            NFONO3: '',
            ZIPCOD: '',
            ELSEXO: '',
            SINNAC: false,
            FECNAC: '',
            TIPPRO: '',
            NOMPAG: '',
            TIPPAG: '',
            FORPAG: '',
            NROCTA: '',
            BANCTA: '',
            SUCCTA: '',
            CODSUC: '',
            NOMRET: '',
            RUTRET: '',
            TIPCLI: '',
            SININT: false,
            FLUPRO: '',
            FLUCLI: '',
            PAGCON: '',
            PAGDIA: '',
            PAGFON: '',
            PAGMAI: '',
            AUTDVE: false,
            USUDVE: '',
            //  FECADV: '',
            BLOLCH: false,
            USUBLH: '',
            //   FECBLH: '',
            CALLES: '',
            NROCAS: '',
            NRODEP: '',
            NROBLO: '',
            SECPOB: '',
            PORDES: '',
            PORSER: '',
            PORREN: '',
            PORRE1: '',
            PORRE2: '',
            SINODC: false,
            LISPRE: '',
            SINEMAIL: false,
            SINFECHA: false,
            CUPO_CREDITO: '',
            SALDO_CREDITO: '',
            UTILIZADO_CREDITO: '',
            ESTADO_CREDITO: '',
            IDSUCURSAL: '',
            RECARGO_FLAG: false,
            RECARGO_MONTO: '',
            FLAG_SIGA: '',
            FLAG_EXT: ''
        });
        toggle();
    };

    const handleConfirmClose = () => {
        setShowConfirm(false);
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={handleCancel} size="lg" backdrop="static">
            <ModalHeader toggle={handleCancel}>
                <i className="ri-edit-line me-2"></i>
                Modificar Cliente
            </ModalHeader>
            <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                {saveError && (
                    <ErrorAlert error={saveError} onDismiss={() => setSaveError('')} />
                )}
                {loadingCliente ? (
                    <div className="text-center">Cargando datos del cliente...</div>
                ) : (
                    <Form onSubmit={handleSubmit}>
                        <div className="d-flex align-items-center my-3">
                            <div className="flex-grow-1 border-top"></div>
                            <span className="mx-3 text-muted fw-bold">Campos Obligatorios</span>
                            <div className="flex-grow-1 border-top"></div>
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <FormGroup>
                                    <Label for="CLIPRO">RUT</Label>
                                    <Input
                                        type="text"
                                        id="CLIPRO"
                                        name="CLIPRO"
                                        value={formData.CLIPRO}
                                        disabled
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-6">
                                <FormGroup>
                                    <Label for="TPERSO">Tipo de Persona *</Label>
                                    <Select
                                        id="TPERSO"
                                        name="TPERSO"
                                        value={formData.TPERSO ? { value: formData.TPERSO, label: formData.TPERSO === 'P' ? 'Persona Natural' : 'Persona Jurídica' } : null}
                                        onChange={(option) => {
                                            handleInputChange({ target: { name: 'TPERSO', value: option ? option.value : '' } });
                                        }}
                                        options={[
                                            { value: 'P', label: 'Persona Natural' },
                                            { value: 'E', label: 'Persona Jurídica' }
                                        ]}
                                        isSearchable
                                        isClearable
                                        placeholder="Seleccionar..."
                                    />
                                    {validationErrors.TPERSO && (
                                        <div className="text-danger" style={{ fontSize: '0.875em', marginTop: '0.25rem' }}>{validationErrors.TPERSO}</div>
                                    )}
                                </FormGroup>
                            </div>
                        </div>

                        {formData.TPERSO === 'E' && (
                            <div className="row">
                                <div className="col-12">
                                    <FormGroup>
                                        <Label for="RAZSOC">Razón Social *</Label>
                                        <Input
                                            type="text"
                                            id="RAZSOC"
                                            name="RAZSOC"
                                            value={formData.RAZSOC}
                                            onChange={handleInputChange}
                                            invalid={!!validationErrors.RAZSOC}
                                        />
                                        {validationErrors.RAZSOC && (
                                            <FormFeedback>{validationErrors.RAZSOC}</FormFeedback>
                                        )}
                                    </FormGroup>
                                </div>
                            </div>
                        )}

                        {formData.TPERSO === 'P' && (
                            <div className="row">
                                <div className="col-4">
                                    <FormGroup>
                                        <Label for="NOMNOM">Nombres *</Label>
                                        <Input
                                            type="text"
                                            id="NOMNOM"
                                            name="NOMNOM"
                                            value={formData.NOMNOM}
                                            onChange={handleInputChange}
                                            invalid={!!validationErrors.NOMNOM}
                                        />
                                        {validationErrors.NOMNOM && (
                                            <FormFeedback>{validationErrors.NOMNOM}</FormFeedback>
                                        )}
                                    </FormGroup>
                                </div>
                                <div className="col-4">
                                    <FormGroup>
                                        <Label for="APEPAT">Apellido Paterno *</Label>
                                        <Input
                                            type="text"
                                            id="APEPAT"
                                            name="APEPAT"
                                            value={formData.APEPAT}
                                            onChange={handleInputChange}
                                            invalid={!!validationErrors.APEPAT}
                                        />
                                        {validationErrors.APEPAT && (
                                            <FormFeedback>{validationErrors.APEPAT}</FormFeedback>
                                        )}
                                    </FormGroup>
                                </div>
                                <div className="col-4">
                                    <FormGroup>
                                        <Label for="APEMAT">Apellido Materno *</Label>
                                        <Input
                                            type="text"
                                            id="APEMAT"
                                            name="APEMAT"
                                            value={formData.APEMAT}
                                            onChange={handleInputChange}
                                            invalid={!!validationErrors.APEMAT}
                                        />
                                        {validationErrors.APEMAT && (
                                            <FormFeedback>{validationErrors.APEMAT}</FormFeedback>
                                        )}
                                    </FormGroup>
                                </div>
                            </div>
                        )}

                        <div className="row">
                            <div className="col-12">
                                <FormGroup>
                                    <Label for="DIRECC">Dirección *</Label>
                                    <Input
                                        type="text"
                                        id="DIRECC"
                                        name="DIRECC"
                                        value={formData.DIRECC}
                                        onChange={handleInputChange}
                                        invalid={!!validationErrors.DIRECC}
                                    />
                                    {validationErrors.DIRECC && (
                                        <FormFeedback>{validationErrors.DIRECC}</FormFeedback>
                                    )}
                                </FormGroup>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <FormGroup>
                                    <Label for="CIUDAD">Ciudad *</Label>
                                    <Input
                                        type="text"
                                        id="CIUDAD"
                                        name="CIUDAD"
                                        value={formData.CIUDAD}
                                        onChange={handleInputChange}
                                        invalid={!!validationErrors.CIUDAD}
                                    />
                                    {validationErrors.CIUDAD && (
                                        <FormFeedback>{validationErrors.CIUDAD}</FormFeedback>
                                    )}
                                </FormGroup>
                            </div>
                            <div className="col-6">
                                <FormGroup>
                                    <Label for="COMUNA">Comuna *</Label>
                                    <Input
                                        type="text"
                                        id="COMUNA"
                                        name="COMUNA"
                                        value={formData.COMUNA}
                                        onChange={handleInputChange}
                                        invalid={!!validationErrors.COMUNA}
                                    />
                                    {validationErrors.COMUNA && (
                                        <FormFeedback>{validationErrors.COMUNA}</FormFeedback>
                                    )}
                                </FormGroup>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <FormGroup>
                                    <Label for="NFONO1">Teléfono 1 *</Label>
                                    <Input
                                        type="tel"
                                        id="NFONO1"
                                        name="NFONO1"
                                        value={formData.NFONO1}
                                        onChange={handleInputChange}
                                        invalid={!!validationErrors.NFONO1}
                                    />
                                    {validationErrors.NFONO1 && (
                                        <FormFeedback>{validationErrors.NFONO1}</FormFeedback>
                                    )}
                                </FormGroup>
                            </div>
                            <div className="col-6">
                                <FormGroup>
                                    <Label for="ELGIRO">Giro *</Label>
                                    <Input
                                        type="text"
                                        id="ELGIRO"
                                        name="ELGIRO"
                                        value={formData.ELGIRO}
                                        onChange={handleInputChange}
                                        invalid={!!validationErrors.ELGIRO}
                                    />
                                    {validationErrors.ELGIRO && (
                                        <FormFeedback>{validationErrors.ELGIRO}</FormFeedback>
                                    )}
                                </FormGroup>
                            </div>
                        </div>

                        {!formData.SINEMAIL && (
                            <div className="row">
                                <div className="col-12">
                                    <FormGroup>
                                        <Label for="CEMAIL">Correo Electrónico *</Label>
                                        <Input
                                            type="email"
                                            id="CEMAIL"
                                            name="CEMAIL"
                                            value={formData.CEMAIL}
                                            onChange={handleInputChange}
                                            invalid={!!validationErrors.CEMAIL}
                                        />
                                        {validationErrors.CEMAIL && (
                                            <FormFeedback>{validationErrors.CEMAIL}</FormFeedback>
                                        )}
                                    </FormGroup>
                                </div>
                            </div>
                        )}

                        <div className="row">
                            <div className="col-12">
                                <FormGroup check>
                                    <Label check>
                                        <Input
                                            type="checkbox"
                                            id="SINEMAIL"
                                            name="SINEMAIL"
                                            checked={formData.SINEMAIL}
                                            onChange={handleCheckboxChange}
                                        />
                                        Cliente sin Email
                                    </Label>
                                </FormGroup>
                            </div>
                        </div>

                        <div className="d-flex align-items-center my-3">
                            <div className="flex-grow-1 border-top"></div>
                            <span className="mx-3 text-muted fw-bold">Campos Opcionales</span>
                            <div className="flex-grow-1 border-top"></div>
                        </div>

                        <div className="row">
                            <div className="col-3">
                                <FormGroup>
                                    <Label for="CALLES">Calle</Label>
                                    <Input
                                        type="text"
                                        id="CALLES"
                                        name="CALLES"
                                        value={formData.CALLES}
                                        onChange={handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-3">
                                <FormGroup>
                                    <Label for="NROCAS">N° Casa</Label>
                                    <Input
                                        type="text"
                                        id="NROCAS"
                                        name="NROCAS"
                                        value={formData.NROCAS}
                                        onChange={handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-3">
                                <FormGroup>
                                    <Label for="NRODEP">N° Depto</Label>
                                    <Input
                                        type="text"
                                        id="NRODEP"
                                        name="NRODEP"
                                        value={formData.NRODEP}
                                        onChange={handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-3">
                                <FormGroup>
                                    <Label for="NROBLO">N° Block</Label>
                                    <Input
                                        type="text"
                                        id="NROBLO"
                                        name="NROBLO"
                                        value={formData.NROBLO}
                                        onChange={handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <FormGroup>
                                    <Label for="SECPOB">Sector/Población</Label>
                                    <Input
                                        type="text"
                                        id="SECPOB"
                                        name="SECPOB"
                                        value={formData.SECPOB}
                                        onChange={handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-6">
                                <FormGroup>
                                    <Label for="COPAIS">Código País</Label>
                                    <Input
                                        type="text"
                                        id="COPAIS"
                                        name="COPAIS"
                                        value={formData.COPAIS}
                                        onChange={handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-4">
                                <FormGroup>
                                    <Label for="NFONO2">Teléfono 2</Label>
                                    <Input
                                        type="tel"
                                        id="NFONO2"
                                        name="NFONO2"
                                        value={formData.NFONO2}
                                        onChange={handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-4">
                                <FormGroup>
                                    <Label for="NFONO3">Teléfono 3</Label>
                                    <Input
                                        type="tel"
                                        id="NFONO3"
                                        name="NFONO3"
                                        value={formData.NFONO3}
                                        onChange={handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-4">
                                <FormGroup>
                                    <Label for="CONTAC">Persona de Contacto</Label>
                                    <Input
                                        type="text"
                                        id="CONTAC"
                                        name="CONTAC"
                                        value={formData.CONTAC}
                                        onChange={handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-4">
                                <FormGroup>
                                    <Label for="FECNAC">Fecha de Nacimiento</Label>
                                    <Input
                                        type="date"
                                        id="FECNAC"
                                        name="FECNAC"
                                        value={formData.FECNAC}
                                        onChange={handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-4">
                                <FormGroup check className="mt-4">
                                    <Label check>
                                        <Input
                                            type="checkbox"
                                            id="SINFECHA"
                                            name="SINFECHA"
                                            checked={formData.SINFECHA}
                                            onChange={handleCheckboxChange}
                                        />
                                        Sin Fecha de Nacimiento
                                    </Label>
                                </FormGroup>
                            </div>
                            <div className="col-4">
                                <FormGroup check className="mt-4">
                                    <Label check>
                                        <Input
                                            type="checkbox"
                                            id="SINNAC"
                                            name="SINNAC"
                                            checked={formData.SINNAC}
                                            onChange={handleCheckboxChange}
                                        />
                                        Sin Nacionalidad
                                    </Label>
                                </FormGroup>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-4">
                                <FormGroup check>
                                    <Label check>
                                        <Input
                                            type="checkbox"
                                            id="SINODC"
                                            name="SINODC"
                                            checked={formData.SINODC}
                                            onChange={handleCheckboxChange}
                                        />
                                        Sin Orden de Compra
                                    </Label>
                                </FormGroup>
                            </div>
                            <div className="col-4">
                                <FormGroup check>
                                    <Label check>
                                        <Input
                                            type="checkbox"
                                            id="SININT"
                                            name="SININT"
                                            checked={formData.SININT}
                                            onChange={handleCheckboxChange}
                                        />
                                        Sin Intereses
                                    </Label>
                                </FormGroup>
                            </div>
                            <div className="col-4">
                                <FormGroup check>
                                    <Label check>
                                        <Input
                                            type="checkbox"
                                            id="RECARGO_FLAG"
                                            name="RECARGO_FLAG"
                                            checked={formData.RECARGO_FLAG}
                                            onChange={handleCheckboxChange}
                                        />
                                        Con Recargo
                                    </Label>
                                </FormGroup>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <FormGroup check>
                                    <Label check>
                                        <Input
                                            type="checkbox"
                                            id="AUTDVE"
                                            name="AUTDVE"
                                            checked={formData.AUTDVE}
                                            onChange={handleCheckboxChange}
                                        />
                                        Autorización DV
                                    </Label>
                                </FormGroup>
                            </div>
                            <div className="col-6">
                                <FormGroup check>
                                    <Label check>
                                        <Input
                                            type="checkbox"
                                            id="BLOLCH"
                                            name="BLOLCH"
                                            checked={formData.BLOLCH}
                                            onChange={handleCheckboxChange}
                                        />
                                        Bloqueo Cheques
                                    </Label>
                                </FormGroup>
                            </div>
                        </div>
                    </Form>
                )}
            </ModalBody>
            <ModalFooter>
                <Button type="button" color="light" onClick={handleCancel} disabled={updating || loadingCliente}>
                    Cerrar
                </Button>
                <Button type="button" color="light" onClick={handleSubmit} disabled={updating || loadingCliente}>
                    {updating ? (
                        <>
                            <i className="ri-loader-4-line ri-spin-line me-1"></i>
                            Actualizando...
                        </>
                    ) : (
                        'Guardar Cambios'
                    )}
                </Button>
            </ModalFooter>
            <ConfirmCloseModal
                isOpen={showConfirm}
                toggle={() => setShowConfirm(false)}
                onConfirm={handleConfirmClose}
            />
        </Modal>
    );
};

export default ModalModificarCliente;